import React, {Component} from "react";
import styles from './FJStockTipsView.module.less';
import classNames from 'classnames';

class FJStockTipsView extends Component {

	render() {
		let {
			text,
			active
		} = this.props;

		return (
			<div className={classNames(styles.tips, {[styles.active]: active})}>
				<span className={styles.text}>{text}</span>
			</div>
		)
	}

}


export default FJStockTipsView;